<template>
  <v-app id="inspire">
    <custom-drawer :width="247" @toggle_drawer="toggleDrawer" @toggleMini="toggleMini"></custom-drawer>
    <custom-toolbar @toggleMini="toggleMini" @toggleDrawer="mostrarOcultarMenu"></custom-toolbar>
    <v-content>
      <custom-breadcrumb />
      <transition name="page" mode="out-in">
        <router-view :key="$route.fullPath" />
      </transition>
    </v-content>
    <custom-footer></custom-footer>
    <v-snackbar
      v-model="mostrarMensajePrincipalLayout"
      :color="tipoPrincipalLayout"
      :timeout="8000"
      right
    >
      <span v-html="mensajePrincipalLayout"></span>
      <v-btn dark text @click="ocultarMensaje()">Cerrar</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState, mapMutations } from "vuex";

// CORE
import CustomToolbar from "@/components/layout/toolbar";
import CustomDrawer from "@/components/layout/drawer";
import CustomFooter from "@/components/layout/footer";
import CustomBreadcrumb from "@/components/layout/breadcrumb";

export default {
  components: {
    CustomToolbar,
    CustomDrawer,
    CustomFooter,
    CustomBreadcrumb
  },
  created() {
    //de entrada en el móvil el menú aparece oculto
    if (this.$vuetify.breakpoint.xs) {
      this.SET_DRAWER(false);
    }

    if (!this.status.logged) {
      this.$router.push("/login");
    } else {
      if (this.user.userMustChangePassword) {
        this.$router.push("/cambiar-clave");
      }
    }
  },
  computed: {
    ...mapState("global", [
      "drawer",
      "mini",
      "mensajePrincipalLayout",
      "tipoPrincipalLayout",
      "mostrarMensajePrincipalLayout",
      "conexionApi",
    ]),
    ...mapState("authentication", ["status", "user"]),
  },
  data() {
    return {
      dialog: false,
      fab_hidden: false
    };
  },
  watch: {
    status: function(val) {
      if (!val.logged) {
        this.$router.push("/login");
      }
    },
    conexionApi: function(val) {
      if (!val) {
        this.$router.push("/error-conexion");
      }
    }
  },
  mounted() {
    //si no me estoy conectando a la api y no hay conexión, enviamos a la página de error
    if (!this.$store.state.global.conectandoApi && !this.$store.state.global.conexionApi) {
      this.$router.push("/error-conexion");  
    }
  },
  methods: {
    ...mapMutations("global", [
      "SET_DRAWER",
      "SET_MINI",
      "SET_CerrarAlertMensaje"
    ]),
    toggleDrawer: function(visible) {
      this.SET_DRAWER(visible);
    },
    toggleMini: function() {
      this.SET_MINI({
        mini: !this.mini,
        lgAndUp: this.$vuetify.breakpoint.lgAndUp
      });
    },
    mostrarOcultarMenu: function(lgUp) {
      let that = this;
      if (lgUp) {
        that.mini = !that.mini;
        that.SET_DRAWER(true);
      } else {
        that.mini = null;
        let visible = !that.drawer;
        that.SET_DRAWER(visible);
      }
    },
    ocultarMensaje() {
      this.SET_CerrarAlertMensaje();
    }
  }
};
</script>


<style scoped>
#inspire >>> .application--wrap {
  overflow: hidden;
}

.container {
  background-color: #fff;
}
</style>
